import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Row, Skeleton, Spacing, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { DeckStack } from '../DeckStack/DeckStack';
import { formatYearlyAmount } from '../utils/formatOpportunityValues';
import { useTallyCount } from './hooks/useTallyCount';
import styles from './LearningDeck.module.scss';
export const GetLearningDeckTID = (parentTestId)=>getTestIds(parentTestId);
export const LearningDeck = (param)=>{
    let { compact } = param;
    const { LearningDeckTestIds } = useMemo(()=>GetLearningDeckTID(), []);
    const { t: texts } = useLocaleKeys('ai.pulse.section');
    const tally = useTallyCount();
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.root,
        role: "img",
        "aria-label": texts.buildingUp.talliedRevenue(),
        testId: LearningDeckTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(DeckStack, {
            border: "plain",
            size: "placeholder",
            compact: compact,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    gap: Spacing.Space8,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Skeleton, {
                            width: 24,
                            height: 24,
                            skin: "light"
                        }),
                        /*#__PURE__*/ _jsx(Skeleton, {
                            width: "38%",
                            height: 8
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Skeleton, {
                    width: "82%",
                    height: 10
                }),
                /*#__PURE__*/ _jsx(Skeleton, {
                    width: "64%",
                    height: 6
                }),
                /*#__PURE__*/ _jsx(Skeleton, {
                    width: "48%",
                    height: 6
                }),
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "h5",
                    weight: "normal",
                    className: styles.tally,
                    testId: LearningDeckTestIds.Tally(),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            as: "span",
                            variant: "h5",
                            weight: "normal",
                            className: styles.tallyAmount,
                            children: formatYearlyAmount(tally)
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            as: "span",
                            variant: "paragraph2",
                            weight: "light",
                            skin: "secondary",
                            children: texts.perYear()
                        })
                    ]
                })
            ]
        })
    });
};
